import { ExtensionCommunicationService } from '@shared/extension/services/extension-communication.service';
import { UserDetails } from '../models/user-details.model';
import { UserStore } from '../stores/user.store';
import { isRestrictedEmail } from './permissions';

export async function isCurrentUserRestricted(
  extensionCommunicationService: ExtensionCommunicationService,
  userStore: UserStore
): Promise<boolean> {
  const userDetails: UserDetails | null =
    userStore.userDetails$.value || (await extensionCommunicationService.getUserDetails());
  const profileEmail: string = userDetails?.email || (await extensionCommunicationService.getProfileEmail());
  return isRestrictedEmail(profileEmail);
}

export async function isCurrentUserNotRestricted(
  extensionCommunicationService: ExtensionCommunicationService,
  userStore: UserStore
): Promise<boolean> {
  return !(await isCurrentUserRestricted(extensionCommunicationService, userStore));
}
